import { render, staticRenderFns } from "./allotBusiness.vue?vue&type=template&id=024d6f58&scoped=true&"
import script from "./allotBusiness.vue?vue&type=script&lang=js&"
export * from "./allotBusiness.vue?vue&type=script&lang=js&"
import style0 from "./allotBusiness.vue?vue&type=style&index=0&id=024d6f58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024d6f58",
  null
  
)

export default component.exports